// src/hooks/usePatientCTAButtonConfig.ts

import { ROUTES } from "@/routes/routes.config";
import { DASHBOARD_TABS } from "@/constants/dashboardTabs";
import { useNavigate } from "react-router-dom";
import { usePatientInformationService } from "@/rtkQuery/features/hooks/usePatientInformationService";
import { buildDashboardTabUrl } from "./useBuildWithParams";


export const usePatientCTAButtonConfig = (overrideText: string = "Get Started") => {
  const navigate = useNavigate();
  const { patientEntitlements, patientEntitlementsIsLoading } =
    usePatientInformationService(); 

  const getCTAConfig = () => {
    if (patientEntitlementsIsLoading) {
      return {
        text: "Loading...",
        action: () => {},
      };
    }

    const {
      HasPatientInformation,
      PatientInformationValid,
      HasQuestionnaire,
      QuestionnaireValid,
      CanOrderICP,
      CanOrderPDE5,
    } = patientEntitlements || {};

    if (CanOrderICP || CanOrderPDE5 || HasQuestionnaire) {
      return {
        text: "View Products",
        action: () => navigate(ROUTES.PRODUCTS_LIST),
      };
    }

    if (PatientInformationValid) {
      return {
        text: "Take Questionnaire",
        action: () => navigate(ROUTES.HEALTH_QUESTIONNAIRES),
      };
    }
    if (HasPatientInformation) {
      return {
        text: "Update Profile",
        action: () => navigate(buildDashboardTabUrl(DASHBOARD_TABS.UPDATE)),
      };
    }

    if (HasPatientInformation && QuestionnaireValid === false) {
      return {
        text: "Take Questionnaire",
        action: () => navigate(ROUTES.HEALTH_QUESTIONNAIRES),
      };
    }

    return {
      text: overrideText,
      action: () => navigate(ROUTES.QUESTIONNAIRES),
    };
  };

  return {
    ctaButtonConfig: getCTAConfig(),
    patientEntitlementsIsLoading: patientEntitlementsIsLoading,
  };
};
